import { SectionType } from '../../../api/types/others';

export const sectionTypesWithStyle: SectionType[] = [
  'todaysPicks',
  'collectionList',
  'collectionSection',
  'goalBasedCollections',
  'trendingAuthors',
  'bundleList',
  'yourPurchases',
  'goalsList',
  'dailyAluxSessions',
  'recentlyPlayed',
  'recentlyPlayedAuthors',
  'favorites',
  'savedContentGroups',
];

export const sectionTypesWithVisibleItems: SectionType[] = [
  'todaysPicks',
  'collectionList',
  'collectionSection',
  'userNewLessons',
  'userMissedSessions',
  'bundleList',
  'yourPurchases',
  'savedContentGroups',
  'gifts',
  'dailyAluxSessions',
  'favorites',
  'downloads',
  'notes',
  'goalsList',
  'recentlyPlayed',
  'recentlyPlayedAuthors',
  'goalBasedCollections',
  'trendingAuthors',
];

export const sectionTypesWithSeeAllConfig: SectionType[] = [
  'collectionList',
  'collectionListMore',
  'collectionSection',
  'userNewLessons',
  'userMissedSessions',
  'bundleList',
  'savedContentGroups',
  'gifts',
  'favorites',
  'recentlyPlayed',
  'recentlyPlayedAuthors',
  'goalsList',
  'yourPurchases',
];

export const sectionTypesWithFetchRule: SectionType[] = [
  'collectionList',
  'bundleList',
  'goalBasedCollections',
  'collectionListMore',
];
